import { Helmet as HelmetComponent } from 'react-helmet';

import { HelmetProps } from './types';

export const Helmet = ({ title, description }: HelmetProps) => {
  const helmet_title = `Voladeum: ${title}`;
  const helmet_description = description || title;

  return (
    <HelmetComponent>
      <title>{helmet_title}</title>
      <meta name="description" content={helmet_description} />
    </HelmetComponent>
  );
};
